import { render, staticRenderFns } from "./BarberColoringDataSheet.vue?vue&type=template&id=4cc22400"
import script from "./BarberColoringDataSheet.vue?vue&type=script&lang=js"
export * from "./BarberColoringDataSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports